export const Employments = [
  { no: 1, name: "正社員" },
  { no: 2, name: "アルバイト・パート" },
  { no: 3, name: "業務委託" },
  { no: 4, name: "契約社員" },
  { no: 5, name: "その他" },
] as const;
